import { Form } from "react-bootstrap";
import { useStore } from 'react-redux';

export const Checkbox = (props) => {
  const { id, checked, adressenNummer, onChange, editMode, readOnly, label } = props || {};
  const { lieferadressenStorage } = useStore().getState();
  return <Form.Check id={id} className="w-auto">
    <Form.Check.Input
      type="checkbox"
      className="border"
      checked={checked}
      data-lieferadressennummer={adressenNummer}
      data-attribute={id}
      onChange={onChange}
      disabled={lieferadressenStorage.isUpdating() || editMode || readOnly}
    />
    <Form.Check.Label className="aria-visible">
      {label || id}
    </Form.Check.Label>
  </Form.Check>;
};
